function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercardBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 25,
  viewBox: "0 0 35 25"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 23.18,
  x: 0.5,
  y: 0.5,
  rx: 3.5,
  ry: 3.5,
  style: {
    fill: "#fff",
    stroke: "#d9d9d9"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.75 17.29a6.7 6.7 0 0 1-4.43 1.66c-3.77 0-6.82-3.11-6.82-6.96s3.06-6.96 6.82-6.96c1.69 0 3.23.63 4.43 1.66a6.7 6.7 0 0 1 4.43-1.66c3.77 0 6.82 3.11 6.82 6.96s-3.06 6.96-6.82 6.96c-1.69 0-3.23-.63-4.43-1.66",
  style: {
    fillRule: "evenodd",
    fill: "#ed0006"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.75 17.29c1.47-1.28 2.4-3.17 2.4-5.29s-.93-4.02-2.4-5.29a6.7 6.7 0 0 1 4.43-1.66c3.77 0 6.82 3.11 6.82 6.96s-3.06 6.96-6.82 6.96c-1.69 0-3.23-.63-4.43-1.66Z",
  style: {
    fill: "#f9a000",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.75 6.7c1.47 1.28 2.4 3.17 2.4 5.29s-.93 4.02-2.4 5.29c-1.47-1.28-2.4-3.17-2.4-5.29s.93-4.02 2.4-5.29",
  style: {
    fillRule: "evenodd",
    fill: "#ff5e00"
  }
}));
export default SvgMastercardBox;